function init() {
	const read_more_buttons = document.querySelectorAll('.read-more');
	if (read_more_buttons.length === 0) {
		return;
	}
	read_more_buttons.forEach(button => {
		const section = button.closest('section');
		if ( ! section ) {
			return;
		}
		button.addEventListener('click', () => {
			section.classList.add('open')
		})
		const read_less_button = section.querySelector('.read-less');
		if (read_less_button) {
			read_less_button.addEventListener('click', () => {
				section.classList.remove('open');
			})
		}
	})
}

init();
